import {
  SegmentsThumbnailItemDto,
  segmentsGetSegmentThumbnailQueryKey,
  useSegmentsGetSegmentThumbnail,
} from '@mi-front/api-v2';

type UseApiSegmentThumbnailOptions = NonNullable<
  Parameters<typeof useSegmentsGetSegmentThumbnail<SegmentsThumbnailItemDto>>[2]
>['query'];

/**
 * React Query wrapper around api-v2 single-segment thumbnail endpoint.
 */
export function useApiSegmentThumbnail(
  stationId: string,
  segmentId: number,
  options?: UseApiSegmentThumbnailOptions,
) {
  return useSegmentsGetSegmentThumbnail<SegmentsThumbnailItemDto>(stationId, segmentId, {
    query: options,
  });
}

useApiSegmentThumbnail.queryKey = (stationId: string, segmentId: number) =>
  segmentsGetSegmentThumbnailQueryKey(stationId, segmentId);
